<template>
  <div>
    <el-date-picker
      v-bind="date_attrs"
      ref="datePicker"
      v-model="submit_data[data.key]"
      size="default"
      type="date"
      :placeholder="data.desc"
      :format="data.format || 'DD/MM/YYYY'"
      :value-format="data.format || 'DD/MM/YYYY'"
      @keydown.enter="onKeyEnter"
      @change="onChange"
    />
    <input
      ref="dateInput"
      v-mask="formatarMask(data.format)"
      style="display:none;"
    >
  </div>
</template>
<script>

import { mask, moment } from 'apsis-plugin';
import Common from './js/Common';

const Js = Common('sls-date');

export default {
  name: 'SlsDate',
  mixins: [Js],
  emits: ['onKeyEnter'],
  computed: {
    date_attrs() {
      return this.Data.date_attrs || {};
    },
  },
  mounted() {
    const format = this.data.format || 'DD/MM/YYYY';
    this.submit_data[this.data.key] = this.submit_data[this.data.key] ? moment(this.submit_data[this.data.key], format).format(format) : null;
    this.applyMask();
  },
  updated() {
    this.applyMask();
  },
  methods: {
    formatarMask(value) {
      if (!value) return '##/##/####';
      return value.replace(/[a-zA-Z]/g, '#');
    },

    applyMask() {
      if (this.submit_data[this.data.key] !== null) {
        setTimeout(() => {
          const input = this.$el.querySelector('.el-input__inner');
          if (input) {
            mask(input, { value: this.formatarMask(this.data.format) });
          }
        }, 0);
      }
    },
    onKeyEnter() {
      this.$emit('onKeyEnter');
    },
    onChange(v) {
      if (this.events.change) this.events.change(v);
    },
  },
};
</script>
